import React from "react";
import Slider from "react-slick";
import "../../styles/Slider.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Image2 from "../../assets/img/Slider2.png";
import Image3 from "../../assets/img/Slider3.png";
import Image4 from "../../assets/img/Slider4.png";
import Image5 from "../../assets/img/ChedarSlider.png";

const SliderProducts = () => {
  return (
    <div>

      <div className="bg-gradient-banner">
        <div className="cheddar-img">
          <img src={Image5} alt="ImageSlider"/>
        </div>
        <Slider
          dots={true}
          infinite={true}
          slidesToShow={3}
          slidesToScroll={2}
          autoplay={true}
          speed={9000}
          autoplaySpeed={0}
        >
          {[Image2, Image3, Image4].map((img, index) => (
            <div key={index} className="container-slider">
              <img src={img} alt={`Imagen ${index}`}/>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default SliderProducts;
